/***
 *
 *   SIGN UP STEP 2
 *   Auto-select free plan for all new signups.
 *
 **********/

import React, { useContext, useState, useEffect } from "react";
import {
  AuthContext,
  Form,
  Link,
  Event,
  useNavigate,
} from "components/lib";

export function SignupPlan({ t }) {
  const navigate = useNavigate();

  // context
  const authContext = useContext(AuthContext);

  // state - always free plan
  const [inputs, setInputs] = useState(null);

  useEffect(() => {
    setInputs({
      plan: {
        type: "hidden",
        value: "free",
        required: true,
        readonly: true,
      },
    });
  }, []);

  const handlePlanCallback = (res) => {
    Event({
      name: "selected_plan",
      metadata: { plan: res.data.plan },
    });
    authContext.update({
      plan: res.data.plan,
      subscription: res.data.subscription,
    });
    navigate(res.data.onboarded ? "/dashboard" : "/welcome");
  };

  return (
    <div className="d-flex items-center">
      <div className="border border-[#E0E0E0] rounded-[12px] pb-4">
        <div className="px-5 py-3 pb-6 border-bottom border-[#E0E0E0]">
          <h2 className="text-[14px] tracking-[0.16px] font-medium text-[#02172C]">
            {t("auth.signup.plan.title")}
          </h2>
        </div>

        {/* Free Plan Info */}
        <div className="px-5 py-4">
          <div className="p-4 rounded-lg border-2 border-blue-500 bg-blue-50 mb-4">
            <div className="font-semibold text-lg">Free Plan</div>
            <div className="text-sm text-gray-600 mt-2">
              <div>Maps API: 10,000 requests/month</div>
              <div>Geocode API: 25,000 requests/month</div>
              <div>Other APIs: 100,000 requests/month</div>
            </div>
            <div className="text-sm text-gray-500 mt-2">No credit card required</div>
          </div>
        </div>

        {inputs && (
          <div className="px-5">
            <Form
              inputs={inputs}
              url="/api/account/plan"
              method="POST"
              buttonText="Get Started"
              callback={handlePlanCallback}
            />
          </div>
        )}

        <footer className="mt-4 justify-center">
          <Link
            url="/account/profile"
            text={t("auth.signup.plan.footer.link_text")}
          />
        </footer>
      </div>
    </div>
  );
}
